import { FC } from 'react'
import { Link } from 'react-router-dom'

import {
  abbreviate,
  Avatar,
  Ellipsis,
  Item,
  Text,
  VStack,
} from '@revolut-internal/ui-kit'

import { Security } from 'common/security/security'
import { getCurrentShiftPosition } from 'modules/Monitoring/agent/AgentAttendanceDetails/utils/getCurrentShiftPosition'
import { useCreateAgentsRoute } from 'modules/Monitoring/hooks/useCreateAgentsRoute'
import { AgentAttendanceShort } from 'modules/Monitoring/types'
import { humanize } from 'modules/Monitoring/utils/format'
import { formatDuration } from 'modules/Monitoring/utils/formatTimeAndDuration'

type ResourcesPanelAgentDetailsProps = {
  agentDetails: AgentAttendanceShort
}

export const ResourcesPanelAgentDetails: FC<ResourcesPanelAgentDetailsProps> = ({
  agentDetails,
}) => {
  const createAgentsRoute = useCreateAgentsRoute([agentDetails.agent.id])
  const currentPosition = getCurrentShiftPosition(agentDetails.shift.positions)
  const canViewAgents = Security.canViewAgentAttendance

  return (
    <Item
      use={canViewAgents ? Link : undefined}
      to={canViewAgents ? createAgentsRoute() : undefined}
    >
      <Item.Avatar>
        <Avatar>{abbreviate(agentDetails.agent.name)}</Avatar>
      </Item.Avatar>
      <Item.Content>
        <Item.Title>{agentDetails.agent.name}</Item.Title>
        <Item.Description>
          <VStack>
            <Text>
              {humanize(agentDetails.agent.currentStatus)}{' '}
              {agentDetails.agent.currentStatusDuration
                ? `for ${formatDuration(agentDetails.agent.currentStatusDuration)}`
                : ''}
            </Text>
            {currentPosition.currentPosition && (
              <Ellipsis tooltip="always">{currentPosition.currentPosition.name}</Ellipsis>
            )}
          </VStack>
        </Item.Description>
      </Item.Content>
    </Item>
  )
}
